package com.trevorwiebe.timesheet.punch.presentation

import com.trevorwiebe.timesheet.core.domain.model.Holiday
import com.trevorwiebe.timesheet.core.domain.model.Organization
import com.trevorwiebe.timesheet.core.domain.model.Rate
import kotlinx.datetime.LocalDateTime

// This state isn't necessarily static, it just contains data this
// is initialized at start up and then probable will never change.

data class StaticPunchState(
    val organization: Organization? = null,
    val currentPeriod: Pair<LocalDateTime, LocalDateTime>? = null,
    val timeSheetDateList: List<LocalDateTime> = emptyList(),
    val rateList: List<Rate> = emptyList(),
    val holidays: List<Holiday> = emptyList(),
    val hoursMap: List<Pair<String, Double>> = emptyList(),
    // True when an admin is viewing another employee's punches: everything is editable and
    // the employee-only controls (clock in/out, submit pay period) are hidden.
    val isAdmin: Boolean = false,
)
